import { hasCostsColRights, isMassChangeColVisible } from '../helpers';
import templates from '../templates';

class CommonColumns {
  #instance;

  init(instance) {
    this.#instance = instance;
    this.#setColumns();
  }

  #setColumns() {
    const isMassChangeVisible = isMassChangeColVisible(this.#instance);
    const hasCostRight = hasCostsColRights(this.#instance);

    this.#instance.config.columns = [
      {
        name: 'masschange',
        resize: false,
        hide: !isMassChangeVisible,
        label: '',
        isShowCheckbox: false,
        task_types: ['project', 'task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('masschange', this.#instance, task),
      },
      {
        name: 'overdue',
        resize: false,
        label: '',
        order: 0,
        task_types: ['project', 'task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('overdue', this.#instance, task),
      },
      {
        name: 'overload',
        resize: false,
        label: '',
        order: 0,
        task_types: ['task', 'milestone'],
        hide: true,
        isShowCheckbox: true,
        template: task => templates.getCommonColumnTemplate('overload', this.#instance, task),
      },
      {
        name: 'comments',
        resize: false,
        label: '',
        task_types: ['project', 'task', 'milestone'],
        hide: true,
        isShowCheckbox: true,
        template: task => templates.getCommonColumnTemplate('comments', this.#instance, task),
      },
      {
        name: 'attachments',
        resize: false,
        label: '',
        task_types: ['project', 'task', 'milestone'],
        hide: true,
        isShowCheckbox: true,
        template: task => templates.getCommonColumnTemplate('attachments', this.#instance, task),
      },
      {
        name: 'wbs',
        label: ' ',
        task_types: ['project', 'task', 'milestone', 'button'],
        hide: false,
        isShowCheckbox: true,
        template: task => templates.getCommonColumnTemplate('wbs', this.#instance, task),
      },
      {
        name: 'text',
        tree: true,
        resize: true,
        hide: false,
        control_type: 'text',
        label: `<span class="grid_head_cel_label">${__('gantt_grid_task_name')}</span>`,
        task_types: ['project', 'task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('text', this.#instance, task),
      },
      {
        name: 'resource_id',
        align: 'center',
        label: __('gantt_grid_assigned'),
        resize: true,
        hide: false,
        isShowCheckbox: true,
        control_type: 'multiselect',
        task_types: ['task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('resource_id', this.#instance, task),
      },
      {
        align: 'center',
        name: 'start_date',
        resize: true,
        hide: false,
        isShowCheckbox: true,
        label: `<span class="grid_head_cel_label">${__('gantt_grid_start_date')}</span>`,
        control_type: 'datepicker',
        task_types: ['project', 'task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('start_date', this.#instance, task),
      },
      {
        align: 'center',
        name: 'end_date',
        resize: true,
        hide: false,
        isShowCheckbox: true,
        label: `<span class='grid_head_cel_label'>${__('gantt_grid_end_date')}</span>`,
        control_type: 'datepicker',
        task_types: ['task'],
        template: task => templates.getCommonColumnTemplate('end_date', this.#instance, task),
      },
      {
        align: 'center',
        name: 'create_date',
        resize: true,
        hide: false,
        isShowCheckbox: true,
        label: `<span class='grid_head_cel_label'>${__('gantt_grid_create_date')}</span>`,
        control_type: 'datepicker',
        task_types: ['project', 'task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('create_date', this.#instance, task),
      },
      {
        align: 'center',
        label: __('gantt_grid_creator'),
        name: 'creator',
        resize: true,
        hide: false,
        isShowCheckbox: true,
        control_type: 'text',
        task_types: ['task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('creator', this.#instance, task),
      },
      {
        align: 'right',
        name: 'duration',
        label: `<span class="grid_head_cel_label">${__('gantt_grid_duration')}</span>`,
        resize: true,
        hide: false,
        isShowCheckbox: true,
        control_type: 'text',
        task_types: ['task'],
        template: task => templates.getCommonColumnTemplate('duration', this.#instance, task),
      },
      {
        align: 'right',
        name: 'estimation',
        label: `<span class='grid_head_cel_label'>${__('gantt_grid_estimation')}</span>`,
        resize: true,
        hide: false,
        isShowCheckbox: true,
        control_type: 'text',
        task_types: ['task'],
        template: (task, isBaseline, baselineState) => templates.getCommonColumnTemplate('estimation', this.#instance, task, isBaseline, baselineState),
      },
      {
        align: 'right',
        name: 'time_tracking',
        label: `<span class='grid_head_cel_label'>${__('gantt_grid_time_tracking')}</span>`,
        resize: true,
        hide: false,
        isShowCheckbox: true,
        control_type: 'time_tracking',
        task_types: ['task', 'milestone', 'project'],
        template: (task, isBaseline, baselineState) => templates.getCommonColumnTemplate('time_tracking', this.#instance, task, isBaseline, baselineState),
      },
      {
        align: 'center',
        name: 'progress',
        label: `<span class='grid_head_cel_label'>${__('gantt_grid_progress')}</span>`,
        hide: false,
        isShowCheckbox: true,
        resize: true,
        control_type: 'counter',
        task_types: ['task', 'milestone'],
        template: task => templates.getCommonColumnTemplate('progress', this.#instance, task),
      },
    ];

    if (hasCostRight) {
      this.#instance.config.columns.push({
        align: 'center',
        name: 'total_price',
        label: __('gantt_grid_total_price'),
        resize: true,
        isShowCheckbox: true,
        hide: false,
        template: (task, isBaseline, baselineState) => templates.getCommonColumnTemplate('total_price', this.#instance, task, isBaseline, baselineState),
      });

      this.#instance.config.columns.push({
        align: 'center',
        name: 'actual_cost',
        label: __('gantt_grid_actual_cost'),
        resize: true,
        hide: false,
        isShowCheckbox: true,
        template: (task, isBaseline, baselineState) => templates.getCommonColumnTemplate('actual_cost', this.#instance, task, isBaseline, baselineState),
      });
    }

    this.#instance.config.columns.push({
      align: 'left',
      name: 'predecessors',
      label: `<span class='grid_head_cel_label'>${__('gantt_grid_predecessors')}</span>`,
      resize: true,
      hide: false,
      isShowCheckbox: true,
      template: task => templates.getCommonColumnTemplate('predecessors', this.#instance, task),
    });
  }
}

export default new CommonColumns();
